<template>
	<v-container fluid>
		<v-row>
			<v-col cols="12" lg="12" class="pb-0 pt-0">
				<v-card flat>
					<v-card-text class="pb-0 pt-2">
						<v-row>
							<v-col v-if="$myStore.state.user.user_role_id == 1" class="d-flex justify-start pa-0 pl-2">
								<v-btn color="primary" @click="addClick">
									<v-icon small>fa-plus</v-icon>&nbsp;&nbsp;{{ $t('buttons.add') }}
								</v-btn>
							</v-col>
							<v-col v-else></v-col>
							<v-col class="d-flex justify-center pb-0 pt-0">
								<v-card-title class="text-center pa-2 pb-2 pt-0">
									{{ $t('titles.internalDocuments') }}</v-card-title
								>
							</v-col>
							<v-col></v-col>
						</v-row>
						<v-row>
							<v-col class="pt-0 pb-0">
								<TheTable
									:additional-filters="internalDocumentsTable.additionalFilters"
									:default-sort="internalDocumentsTable.defaultSort"
									:excel="false"
									:fields="internalDocumentsTable.headers"
									:header-selection-key="'internal-document-headers'"
									:height="internalDocumentsTable.height"
									:total-records="internalDocumentsTable.total"
									:filter-save-key="'internal-document-filters'"
									@headers="selectHeaders"
									@reload="reloadData"
								>
									<tr
										v-for="(item, key) in internalDocumentsTable.items"
										:key="key"
										:class="{ 'cursor-pointer': true }"
										@contextmenu.prevent="editClick(item.id)"
									>
										<td
											v-if="internalDocumentsTable.selectedHeaders.includes('name')"
											@click="$myStore.state.user.user_role_id == 1 ? editClick(item.id) : null"
										>
											{{ item.name }}
										</td>
										<td
											v-if="internalDocumentsTable.selectedHeaders.includes('updated_at')"
											@click="$myStore.state.user.user_role_id == 1 ? editClick(item.id) : null"
										>
											{{ item.updated_at }}
										</td>
										<td
											v-if="internalDocumentsTable.selectedHeaders.includes('author_id')"
											@click="$myStore.state.user.user_role_id == 1 ? editClick(item.id) : null"
										>
											{{ item.author.full_name }}
										</td>
										<td v-if="internalDocumentsTable.selectedHeaders.includes('document')">
											<Upload
												:readonly="true"
												:showBorder="false"
												v-model="item.uploaded_file"
											></Upload>
										</td>
										<td v-if="$myStore.state.user.user_role_id == 1">
											<v-tooltip bottom>
												<template v-slot:activator="{ on, attrs }">
													<v-btn
														icon
														small
														v-bind="attrs"
														@click="deleteClick(item.id)"
														v-on="on"
													>
														<v-icon small>fas fa-trash</v-icon>
													</v-btn>
												</template>
												<span>{{ $t('tooltips.deleteDocument') }}</span>
											</v-tooltip>
										</td>
									</tr>
								</TheTable>
							</v-col>
						</v-row>
					</v-card-text>
				</v-card>
			</v-col>
		</v-row>
		<v-col>
			<Modal :show-modal="showModal">
				<Document
					:documentId="selectedDocument"
					:inEditMode="true"
					@close="closeModal"
					@reloadData="reloadData(internalDocumentsTable.lastRequest)"
				></Document>
			</Modal>
		</v-col>
	</v-container>
</template>

<script>
import TheTable from '../../trinkets/TheTable';
import Upload from '../../trinkets/Upload';
import Modal from '../../trinkets/Modal';
import Document from './Document';

export default {
	name: 'InternalDocuments',
	components: { TheTable, Upload, Modal, Document },
	data: function () {
		return {
			internalDocumentsTable: {
				selectedHeaders: [],
				headers: [
					{ text: this.$t('fields.name'), value: 'name', type: 'string', allowFilter: true },
					{
						text: this.$t('fields.updatedAt'),
						value: 'updated_at',
						type: '',
						allowFilter: true,
					},
					{
						text: this.$t('fields.lastModified'),
						value: 'author_id',
						type: 'dropdown|users',
						allowFilter: true,
					},
					{
						text: this.$t('fields.document'),
						value: 'document',
						type: 'dropdown|internal-documents',
						allowFilter: true,
					},
					{ text: '', value: 'actions', type: '', sortable: false, width: '100px', allowFilter: false },
				],
				additionalFilters: [
					{
						text: this.$t('fields.updatedAt'),
						value: 'updated_at',
						type: 'date_range',
						allowFilter: true,
					},
				],
				items: [],
				total: 0,
				lastRequest: null,
				height: '0px',
				defaultSort: {
					field: 'updated_at',
					descending: true,
				},
			},
			showModal: false,
			selectedDocument: 0,
		};
	},
	methods: {
		addClick() {
			this.showModal = true;
			this.selectedDocument = 0;
		},
		closeModal() {
			this.showModal = false;
		},
		editClick(selectedDocument) {
			this.selectedDocument = selectedDocument;
			this.showModal = true;
		},
		deleteClick(id) {
			let vm = this;
			this.$verify(this.$t('alerts.fileDeletionQuestion'), (result) => {
				if (result) {
					vm.$APICall('delete', 'internal-documents/' + id + '/delete', { id: id }, (data, success) => {
						if (success) {
							vm.$notify(vm.$t('alerts.documentDeleteSuccess'));
							vm.reloadData(vm.internalDocumentsTable.lastRequest);
						} else {
							vm.$alert(vm.$t('alerts.basicError'));
						}
					});
				}
			});
		},
		selectHeaders(headers) {
			this.internalDocumentsTable.selectedHeaders = headers;
		},
		reloadData(request) {
			this.internalDocumentsTable.lastRequest = request;
			let vm = this;
			this.$APICall(
				'get',
				'internal-documents',
				request,
				(data, success) => {
					if (success) {
						vm.internalDocumentsTable.items = data.items;
						vm.internalDocumentsTable.total = data.total;
					} else {
						vm.$alert(vm.$t('alerts.basicError'));
					}
				},
				false
			);
		},
		resolveWindowResize() {
			this.internalDocumentsTable.height = window.innerHeight - 235 + 'px';
		},
	},
	mounted() {
		if (!this.$myStore.state.loggedIn) {
			this.$router.replace('/login');
		}

		let vm = this;

		this.$myStore.commit('setBreadcrumbs', [
			{
				text: vm.$t('modules.internalDocuments'),
				href: '/#/internal-documents',
				disabled: true,
			},
		]);

		window.addEventListener('resize', this.resolveWindowResize);
		this.resolveWindowResize();
	},
};
</script>

<style scoped></style>
